<script>
import Vue from 'vue';
import { LangSelector } from '@phila/phila-ui';
import { loadLanguageAsync } from '../i18n.js';
export default {
  extends: LangSelector,
  created () {
    let initLang = localStorage.getItem('lang') || navigator.language || 'en-US';
    this.changeLang(initLang);
  },
  methods: {
    changeLang(lang) {
      loadLanguageAsync(lang);
      localStorage.setItem('lang', lang);
    },
  },
};
</script>